import { useEffect, useRef } from 'react';

interface NativePlayerProps {
  onReady: () => void;
  src: string;
}

export const NativePlayer = ({ onReady, src }: NativePlayerProps) => {
  const playerRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    playerRef.current?.focus();
    onReady();
  }, [onReady]);

  return (
    <video
      ref={playerRef}
      id="itg-player"
      className="player-surface h-full max-h-full w-full object-contain outline-none"
      data-player-root
      controls
      autoPlay
      muted
      playsInline
    >
      <source src={src} type="video/mp4" />
    </video>
  );
};
